import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=3588d3f6&scoped=true&"
import script from "./SearchInput.vue?vue&type=script&lang=js&"
export * from "./SearchInput.vue?vue&type=script&lang=js&"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=3588d3f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588d3f6",
  null
  
)

export default component.exports